import type { ReactNode } from "react";
import PageBreadcrumb, { type Crumb } from "./PageBreadcrumb";

interface PageHeaderProps {
  crumbs: Crumb[];
  kicker?: string;
  title: string;
  description?: string;
  aside?: ReactNode;
}

export default function PageHeader({ crumbs, kicker, title, description, aside }: PageHeaderProps) {
  return (
    <div className="w-full border-b border-background-200 bg-background-100/70">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-8 md:px-6 md:py-10">
        <PageBreadcrumb items={crumbs} />
        <div className="mt-4 flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div className="min-w-0">
            {kicker && (
              <p className="mb-2 flex items-center gap-2 text-[11px] tracking-[0.24em] text-accent-600 uppercase">
                <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
                {kicker}
              </p>
            )}
            <h1 className="font-heading text-2xl leading-snug text-foreground-950 md:text-3xl">{title}</h1>
            {description && (
              <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{description}</p>
            )}
          </div>
          {aside && <div className="shrink-0">{aside}</div>}
        </div>
      </div>
    </div>
  );
}